/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getPageTargetingDataReq, patchPageTargetingDataReq } from '../../api/pageTargeting'

const initialState = {
  data: {
    targetingType_CATEGORY: null,
    targetingType_CATEGORY_init: null,
    targetingType_PDP: null,
    targetingType_PDP_init: null,
    targetingType_SEARCH: null,
    targetingType_SEARCH_init: null,
    targetingType_PRODUCT: null,
    targetingType_PRODUCT_init: null,
  },
  isDataFetching: false,
  isItemsUpdating: false,
  additionalInfo: {
    productID: null,
    accountID: null,
    channelID: null,
    isBol: true,
  },
}

export const getPageTargetingDataAction = createAsyncThunk(
  'pageTargeting/getPageTargetingDataAction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await getPageTargetingDataReq(data)
      return {
        data: {
          ...response?.data,
        },
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const patchPageTargetingDataAction = createAsyncThunk(
  'pageTargeting/patchPageTargetingDataAction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await patchPageTargetingDataReq(data)
      return {
        data: {
          ...response?.data,
        },
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export const pageTargetingSlice = createSlice({
  name: 'pageTargeting',
  initialState,
  reducers: {
    setAdditionalInfo: (state, action) => {
      state.additionalInfo = {
        ...action.payload,
      }
    },
    updatePageTargetingData: (state, action) => {
      state.data = {
        ...state.data,
        ...action.payload,
      }
    },
    dispose: (state) => {
      state.data = {
        targetingType_CATEGORY: null,
        targetingType_CATEGORY_init: null,
        targetingType_PDP: null,
        targetingType_PDP_init: null,
        targetingType_SEARCH: null,
        targetingType_SEARCH_init: null,
        targetingType_PRODUCT: null,
        targetingType_PRODUCT_init: null,
      }
      state.isDataFetching = false
      state.isItemsUpdating = false
      state.additionalInfo = {
        productID: null,
        accountID: null,
        channelID: null,
        isBol: true,
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // get data
      .addCase(getPageTargetingDataAction.pending, (state) => {
        state.isDataFetching = true
      })
      .addCase(getPageTargetingDataAction.fulfilled, (state, actions) => {
        state.isDataFetching = false
        state.data = {
          targetingType_CATEGORY: actions.payload.data.targetingType_CATEGORY,
          targetingType_CATEGORY_init: actions.payload.data.targetingType_CATEGORY,
          targetingType_PDP: actions.payload.data.targetingType_PDP,
          targetingType_PDP_init: actions.payload.data.targetingType_PDP,
          targetingType_SEARCH: actions.payload.data.targetingType_SEARCH,
          targetingType_SEARCH_init: actions.payload.data.targetingType_SEARCH,
          targetingType_PRODUCT: actions.payload.data.targetingType_PRODUCT,
          targetingType_PRODUCT_init: actions.payload.data.targetingType_PRODUCT,
        }
      })
      .addCase(getPageTargetingDataAction.rejected, (state) => {
        state.isDataFetching = false
      })
      // patch data
      .addCase(patchPageTargetingDataAction.pending, (state) => {
        state.isItemsUpdating = true
      })
      .addCase(patchPageTargetingDataAction.fulfilled, (state) => {
        state.isItemsUpdating = false
        state.data = {
          ...state.data,
          targetingType_CATEGORY_init: state.data.targetingType_CATEGORY,
          targetingType_PDP_init: state.data.targetingType_PDP,
          targetingType_SEARCH_init: state.data.targetingType_SEARCH,
          targetingType_PRODUCT_init: state.data.targetingType_PRODUCT,
        }
      })
      .addCase(patchPageTargetingDataAction.rejected, (state) => {
        state.isItemsUpdating = false
      })
  },
})

// state
export const selectPageTargetingData = (state) => state.pageTargeting.data
export const selectPageTargetingAdditionalInfo = (state) => state.pageTargeting.additionalInfo
// Loaders
export const selectIsPageTargetingDataLoading = (state) => state.pageTargeting.isDataFetching
export const selectIsPageTargetingItemsUpdating = (state) => state.pageTargeting.isItemsUpdating
// actions
export const { setAdditionalInfo, updatePageTargetingData, dispose } = pageTargetingSlice.actions

export default pageTargetingSlice.reducer
